import { getGlowImageUrl, GlowIdTypes } from "@glow/shared";
import classNames from "classnames";
import React from "react";

export const GlowIdAvatar = ({
  size = 40,
  info,
  className,
}: {
  className?: string;
  info: Pick<GlowIdTypes.BasicInfo, "name" | "handle" | "image">;
  size?: number;
}) => {
  return (
    <div
      className={classNames("avatar", className)}
      style={{
        ...(info.image
          ? {
              backgroundImage: `url("${getGlowImageUrl({
                url: info.image,
                width: size,
                height: size,
              })}")`,
            }
          : {
              backgroundColor: "var(--secondary-color)",
            }),
        width: size || undefined,
        height: size || undefined,
      }}
    >
      <style jsx>{`
        .avatar {
          border-radius: 1000px;
          background-position: center;
          background-size: cover;
          background-color: var(--white);
        }
      `}</style>
    </div>
  );
};
